<template>
  <div>
    <h3 class="mb-5">Files</h3>
    <div class="h4 mb-5">上傳檔案，檔案可新增多個</div>

    <!-- itemList -->
    <PageCollapse v-for="(item, i) in download.files" :key="i">
      <template v-slot:head>
        <h3>檔案 {{ i + 1 }}</h3>
      </template>
      <template v-slot:actions>
        <div class="ml-auto">
          <button class="btn square mr-10px" @click="deleteItem(item)">
            <v-icon class="ink-02-medium--text">delete</v-icon>
          </button>
          <button class="btn square mr-10px" @click="downItem(item, i)">
            <v-icon class="ink-02-medium--text">arrow_downward</v-icon>
          </button>
          <button class="btn square" @click="upItem(item, i)">
            <v-icon class="ink-02-medium--text">arrow_upward</v-icon>
          </button>
        </div>
      </template>
      <template v-slot:body>
        <!-- 下載按鈕文字 -->
        <div class="form-item d-flex py-5">
          <div class="w-200px">
            <h4>下載按鈕文字</h4>
          </div>
          <div class="flex-grow-1 flex-basis-0 my-n2">
            <v-text-field
              v-model="item.title"
              outlined
              dense
            ></v-text-field>
          </div>
        </div>

        <!-- 影片上傳 -->
        <div class="d-flex px-5 pt-5 pb-5">
          <div class="w-200px">
            <h4 class="mb-10px">檔案</h4>
            <div class="h5 ink-02-medium--text">
              檔案大小限制：≤ 64 MB <br />
              超過64MB請洽工程師協助上傳
            </div>
          </div>
          <div class="d-flex justify-end flex-grow-1">
            <FileUploader
              v-model="item.file"
              dir="support"></FileUploader>
          </div>
        </div>
      </template>
    </PageCollapse>

    <!-- add team sponsorship -->
    <div class="mt-5">
      <button class="btn btn-outlined w-100 justify-start" @click="addItem">
        <v-icon class="primary--text mr-2">add_circle</v-icon>
        <span>添加檔案</span>
      </button>
    </div>
  </div>
</template>

<script>
import PageCollapse from '@/components/PageCollapse.vue';
import FileUploader from '@/components/FileUploader.vue';

export default {
  props: {
    download: {
      type: Object,
      default: () => ({}),
    },
  },
  components: {
    PageCollapse,
    FileUploader,
  },
  methods: {
    addItem() {
      const template = {
        id: null,
        title: '',
        file: null,
      };
      this.download.files.push(template);
    },
    deleteItem(item) {
      const index = this.download.files.map((option) => option.id).indexOf(item.id);
      this.download.files.splice(index, 1);
    },
    downItem(item, i) {
      // if i is last, then item become the first index
      if (i === this.download.files.length - 1) {
        this.download.files.splice(i, 1);
        this.download.files.unshift(item);
        return;
      }
      // item become next index
      this.download.files.splice(i, 1);
      this.download.files.splice(i + 1, 0, item);
    },
    upItem(item, i) {
      // if i = 0, then item go to the last one
      if (i === 0) {
        this.download.files.splice(i, 1);
        this.download.files.push(item);
        return;
      }
      // item become previous index
      this.download.files.splice(i, 1);
      this.download.files.splice(i - 1, 0, item);
    },
  },
};
</script>

<style></style>
